<template>
  <div>
    <div v-if="!hasChildren" class="">

      <!-- HEAD -->
      <div class="head row p-0 m-0 overflow-hidden">
        <div class="col-12 p-0 m-0 mb-0 mb-lg-5 pb-0 pb-lg-5 position-relative"  data-aos="fade-down" data-aos-easing="ease-out-cubic" data-aos-duration="500">
          <div class="container position-absolute mt-0 mt-lg-5 pt-3 pt-lg-5 px-0 px-lg-3">
            <div class="row justify-content-start justify-content-lg-end m-0 mt-0 mt-lg-5 pt-0 pt-lg-5">
              <div class="col-7 col-lg-10 text-start text-lg-end">
                <h1  v-html="$t('informe.informe_financero')"></h1>
                <div class="col-12 col-lg-6 offset-0 offset-lg-6">
                  <h4>{{ $t("informe.flexibilidad") }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="scrollDownLayer">
            <svg class="scrollDown svg-icon">
              <use :href="`${publicPath}icons.svg#scrollDown`"/>
            </svg>
          </div>
          <img :src="`${publicPath}img/03informe_${locale}.jpg`" class="img-responsive d-none d-lg-block">
          <img :src="`${publicPath}img/03informeMobile_${locale}.jpg`" class="img-responsive d-block d-lg-none" id="imgInforme">
        </div>
      </div>
      <!-- end HEAD -->
    </div>
  </div>

  <div class="container-xxl">
    <div class="row justify-content-between my-5 text-white">
      <div class="col-12 col-lg-5 text-start pe-5">
        <h2 class="mb-5">{{ $t("informe.datos") }}</h2>
        <h4 class="my-4 mt-5">{{ $t("informe.pese") }}</h4>
      </div>
      <div class="col-12 col-lg-6 mb-5 text-start position-relative">
        <!-- GRAFICA 1 -->
        <div class="row px-2 px-lg-0 py-5 position-relative">

          <div class="grfCapa" id="grfCapaA" v-if="capaA">
            <div class="btnClose svg svg-xBtn text-end position-absolute end-0 me-2" @click="capaA=false"></div>
            <p>{{ $t("informe.importe") }}</p>
            <p>{{ $t("informe.las_vendas") }}</p>
          </div>

          <div class="close btnClose text-end position-absolute end-0 me-0" @click="capaA=true"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive" width="25"></div>
          <h5 class="col-10 col-lg-12 p-0 m-0">{{ $t("informe.evolucion") }}</h5>
          <p class="txtGris p-0 m-0"><small>{{ $t("informe.millones_de_euros") }}</small></p>
          <hr class="borderGris my-0 mb-5">

          <div class="grafica">

            <!-- barres de colors -->
            <div class="row g-3 text-center graficaColors">
              <div class="col-2 grf grf01A aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                  <p>{{ $t("informe.1777") }}</p>
              </div>
              <div class="col-2 grf grf01B aos-init aos-animate" data-aos="fade-up" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <p>{{ $t("informe.1861") }}</p>
              </div>
              <div class="col-2 grf grf01C aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                <p>{{ $t("informe.1684") }}</p>
              </div>
              <div class="col-2 grf grf01D aos-init aos-animate" data-aos="fade-up" data-aos-delay="800" data-aos-easing="easy-out" data-aos-duration="1000">
                <p>{{ $t("informe.2053") }}</p>
              </div>
              <div class="col-2 grf grf01E aos-init aos-animate" data-aos="fade-up" data-aos-delay="1100" data-aos-easing="easy-out" data-aos-duration="1000">
                <p>{{ $t("informe.2092") }}</p>
              </div>
            </div>

            <!-- base linies -->
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">2100</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">2000</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1900</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1800</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1700</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1600</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1500</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-4">

              <div class="col-2 text-end txtGris lineGraf">1400</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row justify-content-end text-center">

              <div class="col-2 txtGris">2018</div>
              <div class="col-2 txtGris">2019</div>
              <div class="col-2 txtGris">2020</div>
              <div class="col-2 txtGris">2021</div>
              <div class="col-2 txtGris">2022</div>

            </div>

          </div>

        </div>

        <!-- GRAFICA 2 -->
        <div class="row px-2 px-lg-0 py-5 position-relative">

          <div class="grfCapa" id="grfCapaB" v-if="capaB">
            <div class="btnClose svg svg-xBtn text-end position-absolute end-0 me-2" @click="capaB=false"></div>
            <p>{{ $t("informe.a_lo_largo") }}</p>
            <p>{{ $t("informe.el_ebitda") }}</p>
          </div>

          <div class="close btnClose text-end position-absolute end-0 me-0" @click="capaB=true"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive" width="25"></div>
            <h5 class=" p-0 m-0">{{ $t("informe.resultados") }}</h5>
            <p class="txtGris p-0 m-0"><small>{{ $t("informe.millones_de_euros") }}</small></p>
            <hr class="borderGris my-0 mb-5">

          <div class="grafica">

            <!-- lineas -->
            <div class="row g-3 text-center">


              <div class="line-chart-block block">

                  <div class="grafico aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                    <span data-valor='243' style="border: none">
                       <span data-valor='253'>
                         <span data-valor='306'>
                           <span data-valor='401'>
                             <span data-valor='356'>
                                 </span></span></span></span></span>
                  </div>
                  <div class="grfValues">
                    <div class="col-2 grf grf02A">
                      <h5 class="txtBlau">{{ $t("informe.13_7") }}</h5>
                      <h5><AnimatedNumber
                              ref='counter_G0A'
                              :startAmount='0'
                              :endAmount='243'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                      <div class="col-2 grf grf02B">
                      <h5 class="txtBlau">{{ $t("informe.13_6") }}</h5>
                      <h5><AnimatedNumber
                              ref='counter_G0B'
                              :startAmount='0'
                              :endAmount='253'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf02C">
                      <h5 class="txtBlau">{{ $t("informe.18_2") }}</h5>
                      <h5><AnimatedNumber
                              ref='counter_G0C'
                              :startAmount='0'
                              :endAmount='306'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf02D">
                      <h5 class="txtBlau">{{ $t("informe.19_6") }}</h5>
                      <h5><AnimatedNumber
                              ref='counter_G0D'
                              :startAmount='0'
                              :endAmount='401'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf02E">
                      <h5 class="txtBlau">{{ $t("informe.17_0") }}</h5>
                      <h5><AnimatedNumber
                              ref='counter_G0E'
                              :startAmount='0'
                              :endAmount='356'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>

                  </div>
              </div>

              <div class="line-chart-block block">
                  <div class="grafico grafB aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                    <span data-valorB='95' style="border: none">
                       <span data-valorB='69'>
                         <span data-valorB='60'>
                           <span data-valorB='179'>
                             <span data-valorB='42'>
                                 </span></span></span></span></span>
                  </div>
                  <div class="grfValues">
                    <div class="col-2 grf grf002A">
                      <h5><AnimatedNumber
                              ref='counter_G0AA'
                              :startAmount='0'
                              :endAmount='95'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                      <div class="col-2 grf grf002B">
                      <h5><AnimatedNumber
                              ref='counter_G0BB'
                              :startAmount='0'
                              :endAmount='69'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf002C">
                      <h5><AnimatedNumber
                              ref='counter_G0CC'
                              :startAmount='0'
                              :endAmount='60'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf002D">
                      <h5><AnimatedNumber
                              ref='counter_G0DD'
                              :startAmount='0'
                              :endAmount='179'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>
                    <div class="col-2 grf grf002E">
                      <h5><AnimatedNumber
                              ref='counter_G0EE'
                              :startAmount='0'
                              :endAmount='42'
                              :duration='3'
                              :separator=separator
                              :decimals='0'
                              :autoinit='true'
                      /></h5>
                    </div>

                  </div>
              </div>


            </div>

            <!-- base linies -->
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">440</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">390</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">340</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">290</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">240</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">190</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">140</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">90</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row my-3 my-lg-4">

              <div class="col-2 text-end txtGris lineGraf">40</div>
              <div class="col-10 borderGrisBottom"></div>

            </div>
            <div class="row justify-content-end text-center">

              <div class="col-2 txtGris">2018</div>
              <div class="col-2 txtGris">2019</div>
              <div class="col-2 txtGris">2020</div>
              <div class="col-2 txtGris">2021</div>
              <div class="col-2 txtGris">2022</div>

            </div>

            <div class="row justify-content-end p-0 g-0 m-0 my-5">
              <div class="col-4 col-lg-5 txtGris"><small>{{ $t("informe.porcentaje_ebitda") }}</small></div>
              <div class="col-3 col-lg-2 txtGris"><small>{{ $t("informe.ebitda") }}<img :src="`${publicPath}img/EBITDA.png`" class="img-responsive ms-2" width="15"></small></div>
              <div class="col-5 col-lg-3 txtGris"><small>{{ $t("informe.beneficio_neto") }}<img :src="`${publicPath}img/BENEFICIO NETO.png`" class="img-responsive ms-2" width="15"></small></div>
            </div>

          </div>


        </div>

        <!-- GRAFICA 3 -->
        <div class="row px-2 px-lg-0 py-5 position-relative">

          <div class="grfCapa" id="grfCapaC" v-if="capaC">
            <div class="btnClose svg svg-xBtn text-end position-absolute end-0 me-2" @click="capaC=false"></div>
            <p>{{ $t("informe.inversiones_correintes") }}</p>
            <p>{{ $t("informe.el_importe") }}</p>
            <p>{{ $t("informe.estructura_financiera") }}</p>
            <p v-html="$t('informe.el_patrimonio_neto')"></p>
          </div>

          <div class="close btnClose text-end position-absolute end-0 me-0" @click="capaC=true"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive" width="25"></div>
          <h5 class=" col-10 p-0 m-0">{{ $t("informe.inverdiones_corrientes") }}</h5>
          <p class="txtGris p-0 m-0"><small>{{ $t("informe.millones_de_euros") }}</small></p>
          <hr class="borderGris my-0 mb-5">

          <div class="grafica">

            <!-- animacions colors -->

            <!-- base linies -->
            <div class="row my-4">

              <div class="col-2 text-start txtGris p-0 m-0 lineGraf">{{ $t("informe.total_patrimonio") }}</div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_A'
                        :startAmount='0'
                        :endAmount='1305'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_B'
                        :startAmount='0'
                        :endAmount='1402'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_C'
                        :startAmount='0'
                        :endAmount='1289'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_D'
                        :startAmount='0'
                        :endAmount='1552'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_E'
                        :startAmount='0'
                        :endAmount='1707'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>

            </div>
            <div class="row my-4">

              <div class="col-2 p-0 m-0  text-start txtGris lineGraf">{{ $t("informe.in_corrientes") }}</div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_AA'
                        :startAmount='0'
                        :endAmount='153'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_BB'
                        :startAmount='0'
                        :endAmount='154'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                      ref='counter_CC'
                      :startAmount='0'
                      :endAmount='106'
                      :duration='3'
                      :separator=separator
                      :decimals='0'
                      :autoinit='true'
              />
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_DD'
                        :startAmount='0'
                        :endAmount='124'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_EE'
                        :startAmount='0'
                        :endAmount='135'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />
              </h4></div>

            </div>
            <div class="row my-4">

              <div class="col-2 p-0 m-0 text-start txtGris lineGraf">{{ $t("informe.sit_financera_neta") }}</div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                (<AnimatedNumber
                        ref='counter_AAA'
                        :startAmount='0'
                        :endAmount='378'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />)
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                (<AnimatedNumber
                        ref='counter_BBB'
                        :startAmount='0'
                        :endAmount='365'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />)</h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>                <AnimatedNumber
                      ref='counter_CCC'
                      :startAmount='0'
                      :endAmount='194'
                      :duration='3'
                      :separator=separator
                      :decimals='0'
                      :autoinit='true'
              />
              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_DDD'
                        :startAmount='0'
                        :endAmount='117'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>
              <div class="col-2 borderGrisBottom text-center"><h4>
                <AnimatedNumber
                        ref='counter_EEE'
                        :startAmount='0'
                        :endAmount='154'
                        :duration='3'
                        :separator=separator
                        :decimals='0'
                        :autoinit='true'
                />

              </h4></div>

            </div>
            <div class="row justify-content-end text-center">

              <div class="col-2 txtGris">2018</div>
              <div class="col-2 txtGris">2019</div>
              <div class="col-2 txtGris">2020</div>
              <div class="col-2 txtGris">2021</div>
              <div class="col-2 txtGris">2022</div>

            </div>

              <div class="row justify-content-end my-3 my-lg-5">
                <div class="col-12 col-lg-10 txtGris">{{ $t("informe.refleja_saldos") }}</div>
              </div>
              <div class="d-block d-lg-none">
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>


        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer>
    <div class="row p-0 g-0">
      <div class="col-6 border-top border-dark">
        <localized-link to="/fundacion-we-are-water" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
          <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
            <svg class="hoverEfect svg-icon iconFletxaLeft">
              <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
            </svg>
          </div>
          <div class="col-6 col-lg-auto text-start p-0 mt-5">
            <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
            <h2 class="hoverEfect d-none d-lg-block">{{ $t("nav.fundacion-we-are-water") }}</h2>
          </div>
        </localized-link>
      </div>
      <div class="col-6 border-top border-start border-dark">
      </div>
    </div>
  </footer>
  <!-- Footer -->

</template>

<script>
  import AnimatedNumber from 'vue3-autocounter'
  export default {
    components: {
      AnimatedNumber
    },
    props: {
      hasChildren: Boolean
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        locale:this.$i18n.locale,
        separator: '.',
        capaA: false,
        capaB: false,
        capaC: false,
      }
    },
    mounted() {
      document.addEventListener('aos:in:counter', this.startCounter);
      if(this.$i18n.locale=="es"){
        this.separator = '.';
      } else {
        this.separator = ',';
      }
    },
    methods: {
      startCounter() {
        if (this.$refs.counter_A != null) {
          this.$refs.counter_A.start();
        }
        if (this.$refs.counter_B != null) {
          this.$refs.counter_B.start();
        }
        if (this.$refs.counter_C != null) {
          this.$refs.counter_C.start();
        }
        if (this.$refs.counter_D != null) {
          this.$refs.counter_D.start();
        }
        if (this.$refs.counter_E != null) {
          this.$refs.counter_E.start();
        }
        if (this.$refs.counter_AA != null) {
          this.$refs.counter_AA.start();
        }
        if (this.$refs.counter_BB != null) {
          this.$refs.counter_BB.start();
        }
        if (this.$refs.counter_CC != null) {
          this.$refs.counter_CC.start();
        }
        if (this.$refs.counter_DD != null) {
          this.$refs.counter_DD.start();
        }
        if (this.$refs.counter_EE != null) {
          this.$refs.counter_EE.start();
        }
        if (this.$refs.counter_AAA != null) {
          this.$refs.counter_AAA.start();
        }
        if (this.$refs.counter_BBB != null) {
          this.$refs.counter_BBB.start();
        }
        if (this.$refs.counter_CCC != null) {
          this.$refs.counter_CCC.start();
        }
        if (this.$refs.counter_DDD != null) {
          this.$refs.counter_DDD.start();
        }
        if (this.$refs.counter_EEE != null) {
          this.$refs.counter_EEE.start();
        }
        if (this.$refs.counter_G0A != null) {
          this.$refs.counter_G0A.start();
        }
        if (this.$refs.counter_G0B != null) {
          this.$refs.counter_G0B.start();
        }
        if (this.$refs.counter_G0C != null) {
          this.$refs.counter_G0C.start();
        }
        if (this.$refs.counter_G0D != null) {
          this.$refs.counter_G0D.start();
        }
        if (this.$refs.counter_G0E != null) {
          this.$refs.counter_G0E.start();
        }
        if (this.$refs.counter_G0AA != null) {
          this.$refs.counter_G0AA.start();
        }
        if (this.$refs.counter_G0BB != null) {
          this.$refs.counter_G0BB.start();
        }
        if (this.$refs.counter_G0CC != null) {
          this.$refs.counter_G0CC.start();
        }
        if (this.$refs.counter_G0DD != null) {
          this.$refs.counter_G0DD.start();
        }
        if (this.$refs.counter_G0EE != null) {
          this.$refs.counter_G0EE.start();
        }
      }
    }
  }

</script>
